import { useTranslation } from 'react-i18next'
import { queries } from '../../../../api'
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks'
import { openCloseSidebar, setMobileMenu } from '../../../../redux/reducers/messenger/messengerSlice'
import { IconButton } from '../../../../shared/button/IconButton'
import { SvgIcon } from '../../../../shared/icons'
import ChatAvatar from '../../../../shared/image/ChatAvatar'
import { useMobileMenuEffect } from '../../../../utils/useSidebarEffects'
import SliderSection from './SliderSection'
import CommonLeftHeading from '../main-sidebar-tab/common/CommonLeftHeading'
import '../../../../utils/prototype'

const RecentSection = () => {
  const { data } = queries.useGetUserDetails()
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const { sidebarToggle, mobileMenu } = useAppSelector((state) => state.messenger)
  const { allow_status } = useAppSelector((state) => state.settings)

  useMobileMenuEffect(mobileMenu)

  const handleRightClick = () => {
    dispatch(setMobileMenu())
    if (sidebarToggle) {
      dispatch(openCloseSidebar(true))
    }
  }

  const handleToggleSidebar = () => {
    dispatch(openCloseSidebar())
  }

  return (
    <div className="recent">
      <CommonLeftHeading
        hideDefaultClose={true}
        customContent={
          <div className="img-text">
            <div className="chat-box">
              <div className="profile">
                <ChatAvatar data={data?.user} name={data?.user} customClass="user-info avatar-sm" />
              </div>
              <div className="details">
                <div className="d-flex align-items-center">
                  <h5>{data?.user?.name?.firstTwoWords()}</h5>
                  {data?.user?.is_verified && <SvgIcon iconId="blue-tick" className="ms-1 verified-tick" />}
                </div>
                <p>{data?.user?.bio || t('bio_data')}</p>
              </div>
            </div>
          </div>
        }
        customActions={
          <>
            <IconButton
              variant="primary"
              className={`pull-right ms-1 mobile-back ${sidebarToggle ? 'btn-outline-light' : ''}`}
              onClick={handleRightClick}
            >
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                <line x1="3" y1="6" x2="21" y2="6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                <line x1="3" y1="12" x2="21" y2="12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                <line x1="3" y1="18" x2="21" y2="18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
              </svg>
            </IconButton>

            <IconButton className="pull-right left-toggle-icon ms-2" onClick={handleToggleSidebar}>
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                <line x1="3" y1="6" x2="21" y2="6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                <line x1="3" y1="12" x2="21" y2="12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                <line x1="3" y1="18" x2="21" y2="18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
              </svg>
            </IconButton>
          </>
        }
      />
      {!!allow_status && <SliderSection />}
    </div>
  )
}

export default RecentSection
